Vue.component('faq-item', {
    props: [],
    data() {
        return {
            isOpen : false,
        }
    },
    computed: {
        //
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
            $(this.$refs.body).slideToggle()
        }
    },
    mounted() {
        //
    }
});